import { render, staticRenderFns } from "./LearningObjectiveEditor.vue?vue&type=template&id=19e112ce&scoped=true"
import script from "./LearningObjectiveEditor.vue?vue&type=script&lang=js"
export * from "./LearningObjectiveEditor.vue?vue&type=script&lang=js"
import style0 from "./LearningObjectiveEditor.vue?vue&type=style&index=0&id=19e112ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e112ce",
  null
  
)

export default component.exports